module.exports = __webpack_public_path__ + "static/img/wc.9beb365.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teacher/wc.png
// module id = imA7
// module chunks = 2